import {Component, Input, OnChanges, OnInit, SimpleChanges} from '@angular/core';
import {BaseViewElement} from '../base-view-element';
import {PropertySet} from '../../../core/model/helper-models/property-set.model';
import {Property} from '../../../core/model/helper-models/property.model';

@Component({
    selector: 'app-distance-vertical',
    templateUrl: './distance-vertical.component.html',
    styleUrls: ['./distance-vertical.component.scss',
        './../card.scss'],
    standalone: false
})
export class DistanceVerticalComponent extends BaseViewElement implements OnInit, OnChanges
{

    @Input() VerticalDistance: PropertySet;


    Kilometer: Property<any>;

    constructor()
    {
        super('distance-vertical');
    }

    onResize(result: any)
    {
        this.childResizeEvent.emit(result);
    }

    ngOnInit()
    {
        super.ngOnInit();
    }

    ngOnChanges(changes: SimpleChanges): void
    {
        if (this.VerticalDistance != null)
        {
            this.Kilometer = this.VerticalDistance.properties.get('KILOMETER');
        }
    }
}
